import Home from '@/components/pages/fan/Home'
import EditProfile from '@/components/pages/fan/EditProfile'
import Profile from '@/components/pages/fan/Profile'
import ProfilePlaylists from '@/components/pages/fan/ProfilePlaylists'
import PlaylistList from '@/components/pages/fan/PlaylistList'
import PlaylistDetail from '@/components/pages/fan/PlaylistDetail'
import EditPlaylist from '@/components/pages/fan/EditPlaylist'
import History from '@/components/pages/fan/History'
import Downloads from '@/components/pages/fan/Downloads'
import Watchlist from '@/components/pages/fan/Watchlist'
import LiveStream from '@/components/pages/fan/LiveStream'
import Messages from '@/components/pages/fan/Messages'
import BillingInfo from '@/components/pages/fan/BillingInfo'
import PaymentHistory from '@/components/pages/fan/PaymentHistory'
import FollowedArtists from '@/components/pages/fan/FollowedArtists'
import FeaturedVideos from '@/components/pages/artist/FeaturedVideos'
import BlockedUsers from '@/components/pages/fan/BlockedUsers'

export default [
  { path: '/@:handle/', name: 'user-permalink', component: Profile },
  { path: '/home/', name: 'fan-home', component: Home, meta: { userType: 'fan' } },
  { path: '/profile/:id/about/', name: 'fan-profile', component: Profile },
  { path: '/profile/:id/featured/', name: 'fan-featured', component: FeaturedVideos },
  { path: '/profile/edit/', name: 'fan-profile-edit', component: EditProfile },
  { path: '/profile/preview/', name: 'fan-profile-preview', component: Profile, meta: { profilePreview: true } },
  { path: '/profile/following/', name: 'fan-followed-artists', component: FollowedArtists },
  { path: '/profile/blocked/', name: 'fan-blocked-users', component: BlockedUsers },
  { path: '/profile/:id/playlists/', name: 'fan-profile-playlists', component: ProfilePlaylists },
  { path: '/playlists/create/', name: 'fan-playlist-create', component: EditPlaylist },
  { path: '/playlists/my/', name: 'fan-playlist-list', component: PlaylistList, meta: { type: 'my' } },
  { path: '/playlists/following/', name: 'fan-playlist-following', component: PlaylistList, meta: { type: 'following' } },
  { path: '/playlist/:id/', name: 'fan-playlist-detail', component: PlaylistDetail },
  { path: '/playlist/:id/edit/', name: 'fan-playlist-edit', component: EditPlaylist },
  { path: '/history/', name: 'fan-history', component: History },
  { path: '/downloads/', name: 'fan-downloads', component: Downloads },
  { path: '/watchlist/', name: 'fan-watchlist', component: Watchlist },
  { path: '/live/:id/', name: 'fan-live-stream', component: LiveStream },
  { path: '/profile/messages/', name: 'fan-messages', component: Messages },
  { path: '/payments/info/', name: 'fan-billing-info', component: BillingInfo },
  { path: '/payments/history/', name: 'fan-payment-history', component: PaymentHistory }
]



// WEBPACK FOOTER //
// ./src/router/fan.js